export default {
  allClubs: [],
  defaultClubs: null,
  selectedClub: null,
  chosenClubIndex: 0
}



// WEBPACK FOOTER //
// ./src/store/clubs/clubs.states.js